module.exports = __webpack_public_path__ + "img/webull.5df57d3f.svg";